import { FormSubmissionData } from './form-submission-data.model';

export interface IFormSubmission {
    data: FormSubmissionData;
    apiUrl: string;
    recaptchaKey: string;
    recaptchaToken: string;
}

export class FormSubmission {
    data: FormSubmissionData;
    apiUrl: string;
    recaptchaKey: string;
    recaptchaToken: string;

    constructor(config?: IFormSubmission) {
        this.data = config?.data ?? new FormSubmissionData();
        this.apiUrl = config?.apiUrl ?? '';
        this.recaptchaKey = config?.recaptchaKey ?? '';
        this.recaptchaToken = config?.recaptchaToken ?? '';
    }

    isEmpty(): boolean {
        return !this.data;
    }
}
